<template>
	<div v-if="showDevInfo" class="information dev-info" :class="{shrink: shrinkDevInfo}">
		<a class="toggle" :class="{collapse: shrinkDevInfo}" @click="toggleDevinfo"></a>
		<div class="dev-info-wrapper" :class="{hide: shrinkDevInfo}">
			<h5 class="page-header">Dev info:</h5>
			<ul class="list-unstyled">
				<li>Service Name: <span>{{ serviceName }} / {{ routeName }}</span></li>
				<li>Environment: <span>{{ $t(environment) }}</span></li>
				<li>Version:
					<template v-if="!versionEditMode">
						<span @click="() => { versionEditMode = true }" class="pointer">{{ customVersion ? customVersion : currentVersion }}</span>
						<button v-if="customVersion" @click="versionRemove">clear</button>
					</template>
					<template v-else>
						<input type="text" v-model="customVersion" @keypress.enter="versionSet" />
						<button @click="() => { versionEditMode = false }">cancel</button>
					</template>
				</li>
				<li>Channel: <span>{{ channel }}</span></li>
				<li>API Host: <span>{{ webApi }}</span></li>
				<li>CDN Host: <span>{{ cdnHost }}</span></li>
			</ul>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'dev-info',
		description: 'Environment and other dev related information',
		props: {
			serviceName: {
				type: String,
				default: '',
				note: 'Application name'
			},
			routeName: {
				type: String,
				default: '',
				note: 'Application name'
			},
			environment: {
				type: String,
				default: '',
				note: 'Environment information'
			},
			currentVersion: {
				type: String,
				default: '',
				note: 'Current version'
			},
			channel: {
				type: String,
				default: '',
				note: 'channel type: eg: web, aluncher, steam'
			},
			webApi: {
				type: String,
				default: '',
				note: 'Api end point'
			},
			cdnHost: {
				type: String,
				default: '',
				note: 'CDN address'
			},
		},
		data() {
			return {
				shrinkDevInfo: false,
				versionEditMode: false,
				customVersion: '',
			};
		},
		computed: {
			showDevInfo() {
				return this.environment !== 'prod';
			},
			cookiePath() {
				return `/${location.pathname.split('/')[1]}`;
			}
		},
		mounted() {
			if (!this.showDevInfo) return;
			this.checkCookieVersion();
		},
		methods: {
			toggleDevinfo() {
				this.shrinkDevInfo = !this.shrinkDevInfo;
			},
			checkCookieVersion() {
				if (this.$cookie) this.customVersion = this.$cookie.get('index_tag');
			},
			versionSet() {
				if (!this.customVersion) return;
				if (this.$cookie) this.$cookie.set('index_tag', this.customVersion, { path: this.cookiePath });
				this.versionEditMode = false;
				window.location.reload();
			},
			versionRemove() {
				if (this.$cookie) this.$cookie.delete('index_tag', { path: this.cookiePath });
				window.location.reload();
			}
		}
	};
</script>

<style lang="less">
	.dev-info.information {
		.page-header {
			margin: 0 0 5px;
			border-bottom: 1px solid #333740;
		}
		background-color: #171a21;
		margin-top: 15px;
		padding: 10px;
		border: 1px solid #333740;
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5);
		h5 {
			font-size: 15px;
			color: #fff;
		}
		&.dev-info {
			position: absolute;
			z-index: 50;
			top: 70px;
			right: 20px;
			.list-unstyled {
				margin-bottom: 0;
				font-size: 12px;
				li {
					span {
						font-size: 13px;
						color: #00dea6;
					}
				}
			}
			&.shrink {
				width: 42px;
				height:34px;
			}
			.toggle {
				display: block;
				width: 20px;
				height: 20px;
				background: url('../../../static/images/icon-expand-collapse.png') top center;
				position: absolute;
				top: 6px;
				right: 10px;
				cursor: pointer;
				&.collapse {
					background-position: bottom center;
				}
			}
			.dev-info-wrapper {
				animation: fade-in .5s ease-out;
				@keyframes fade-in {
					0% { opacity: 0; }
					100% { opacity: 1; }
				}
			}
			.pointer {
				cursor: pointer;
			}
		}
	}
	@media (max-width: 740px) {
		.dev-info.information {
			display: none;
		}
	}
</style>
